export const messages = {
  en: {
    auditParkingSpaceApply: {
      applyInfo: 'Application Information',
      back: 'Back',
      licensePlate: 'License Plate',
      carType: 'Car Type',
      startRentTime: 'Start Rent Time',
      endRentTime: 'End Rent Time',
      applicant: 'Applicant',
      applicantPhone: 'Applicant Phone',
      applicantId: 'Applicant ID',
      remark: 'Remark',
      auditInfo: 'Audit Information',
      auditResult: 'Audit Result',
      selectResult: 'Please select audit result',
      pass: 'Pass',
      reject: 'Reject',
      selectParkingSpace: 'Select Parking Space',
      select: 'Select',
      auditOpinion: 'Audit Opinion',
      optional: 'Optional',
      submit: 'Submit',
      requiredField: 'Required field',
      parkingLot: 'Parking Lot',
      belongParkingLot: 'Belonging Parking Lot',
      parkingSpace: 'Parking Space',
      parkingStatus: 'Parking Status',
      parkingType: 'Parking Type',
      area: 'Area',
      operation: 'Operation',
      choose: 'Choose',
      parkingLotCode: 'Parking Lot Code',
      parkingSpaceCode: 'Parking Space Code',
      parkingLotType: 'Parking Lot Type',
      groundParking: 'Ground Parking',
      undergroundParking: 'Underground Parking',
      free: 'Free',
      sold: 'Sold',
      rented: 'Rented',
      unknown: 'Unknown'
    }
  },
  zh: {
    auditParkingSpaceApply: {
      applyInfo: '申请信息',
      back: '返回',
      licensePlate: '车牌号',
      carType: '车辆类型',
      startRentTime: '起租时间',
      endRentTime: '结租时间',
      applicant: '申请人',
      applicantPhone: '申请人电话',
      applicantId: '申请人ID',
      remark: '备注',
      auditInfo: '审核信息',
      auditResult: '审核结果',
      selectResult: '请选择审核结果',
      pass: '通过',
      reject: '不通过',
      selectParkingSpace: '选择车位',
      select: '选择',
      auditOpinion: '审核意见',
      optional: '选填',
      submit: '提交',
      requiredField: '必填',
      parkingLot: '停车场',
      belongParkingLot: '所属停车场',
      parkingSpace: '车位',
      parkingStatus: '车位状态',
      parkingType: '车位类型',
      area: '面积',
      operation: '操作',
      choose: '选择',
      parkingLotCode: '停车场编码',
      parkingSpaceCode: '停车位编码',
      parkingLotType: '停车场类型',
      groundParking: '地上停车位',
      undergroundParking: '地下停车位',
      free: '空闲',
      sold: '已售卖',
      rented: '已出租',
unknown: '未知'
    }
  },
  'zh-TW': {
    auditParkingSpaceApply: {
      applyInfo: '申請信息',
      back: '返回',
      licensePlate: '車牌號',
      carType: '車輛類型',
      startRentTime: '起租時間',
      endRentTime: '結租時間',
      applicant: '申請人',
      applicantPhone: '申請人電話',
      applicantId: '申請人ID',
      remark: '備註',
      auditInfo: '審核信息',
      auditResult: '審核結果',
      selectResult: '請選擇審核結果',
      pass: '通過',
      reject: '不通過',
      selectParkingSpace: '選擇車位',
      select: '選擇',
      auditOpinion: '審核意見',
      optional: '選填',
      submit: '提交',
      requiredField: '必填',
      parkingLot: '停車場',
      belongParkingLot: '所屬停車場',
      parkingSpace: '車位',
      parkingStatus: '車位狀態',
      parkingType: '車位類型',
      area: '面積',
      operation: '操作',
      choose: '選擇',
      parkingLotCode: '停車場編碼',
      parkingSpaceCode: '停車位編碼',
      parkingLotType: '停車場類型',
      groundParking: '地上停車位',
      undergroundParking: '地下停車位',
      free: '閒暇',
      sold: '已售賣',
      rented: '已出租',
      unknown: '未知'
    }
  }
}